import * as Yup from "yup";

const initValuesTicketCategory = {
    displayName: "",
    type: "support_type",
    father: "",
    active: true
}

const validationSchemaTicketCategory = Yup.object().shape({
    displayName: Yup.string().required("Por favor agrega el nombre de la categoría."),
    type: Yup.string().required('Por favor agrega el tipo de la categoría.'),
    father: Yup.mixed().nullable()
})

export { validationSchemaTicketCategory, initValuesTicketCategory }